/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import * as THREE from "three";
import { useGLTF, useTexture } from "@react-three/drei";
import model from "./Tunel_V2.glb";
import parede from "./Parede_Diffuse.jpg";
import paredeNormal from "./Parede_Normal.jpg";
import paredeRoughness from "./Parede_Roughness.jpg";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF(model);
  const paredeTexture = useTexture(parede);
  const paredeNormalTexture = useTexture(paredeNormal);
  const paredeRoughnessTexture = useTexture(paredeRoughness);
  Object.entries(materials).forEach(([key, value]) => {
    value.envMapIntensity = props.envMapIntensity;
    value.transparent = true;
    if (value.name === "Asfalto_Bake") {
      // value.envMapIntensity = 0.15;
    }
    if (value.name === "Calcada_Bake") {
      // value.envMapIntensity = 0.15;
    }
    if (value.name === "Parede_Bake") {
      // value.envMapIntensity = 0.15;
      value.map = paredeTexture;
      value.map.flipY = false;
      value.normalMap = paredeNormalTexture;
      value.normalMap.flipY = false;
      value.roughnessMap = paredeRoughnessTexture;
      value.roughnessMap.flipY = false;
    }
  });
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Paredes"
          geometry={nodes.Paredes.geometry}
          material={materials.Parede_Bake}
          position={[-17.31, 1.13, 0]}
        />
        <mesh
          name="Calcada"
          geometry={nodes.Calcada.geometry}
          material={materials.Calcada_Bake}
          material-emissive={new THREE.Color("#ffffff")}
          position={[-17.31, 1.13, 0]}
        />
        <mesh
          name="Asfalto"
          geometry={nodes.Asfalto.geometry}
          material={materials.Asfalto_Bake}
          position={[-17.31, 1.13, 0]}
        />
        <mesh
          name="Trilho"
          geometry={nodes.Trilho.geometry}
          material={materials["Trilho.001"]}
          position={[-17.31, 9.67, 0]}
        />
        <mesh
          name="Suportes"
          geometry={nodes.Suportes.geometry}
          material={materials.Suporte_Bake}
          position={[-17.31, 9.67, 0]}
        />
        <mesh
          name="LuzesAltas"
          geometry={nodes.LuzesAltas.geometry}
          material={materials.LuzesAltas_Bake}
          position={[-17.31, 9.33, 0]}
        />
        <mesh
          name="LuzesBaixas"
          geometry={nodes.LuzesBaixas.geometry}
          material={materials.LuzesBaixas_Bake}
          position={[4.4, 0.64, -0.08]}
          rotation={[-3.13, 0.15, -3.1]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
